import * as deviceAppsService from '../../../services/Rfid/deviceAppsService';
import {gridsNames} from "../../../enums/gridsNames";
import * as gridActionsHelper from "../../../../../infrastructure/js/components/Grid/Utils/gridActionsHelper";

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_RFID_SETTINGS_READERS_AND_ANTENNAS, _fetchDataAction);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    let deviceBusinessId =  getState().administration.getIn(['rfidSettingsPage', 'readersAndAntennasViewData' , 'selectedDeviceApp']).label;

    if (!deviceBusinessId) {
      return Promise.resolve([]);
    }

    let quaryData = {
      deviceOrgBusinessId :getState().login.get('loggedInUser').loggedInOrg.businessId,
      deviceBusinessId: deviceBusinessId
    }
    return deviceAppsService.getDeviceProfile(quaryData).then((res) => {
      return deviceAppsService.getDeviceAppReaders(res.data.profileId);
    });
  }
};

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
